export const shortCodec = (mimeType: string | undefined): string | undefined => {
  if (!mimeType) {
    return undefined;
  }
  const tail = mimeType.split('/')[1];
  return tail ? tail.toLowerCase() : mimeType;
};

export const bpsToKbps = (bps: number): number => Math.round(bps / 1000);
